var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStaff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "55.000000pt",
    height: "42.000000pt",
    viewBox: "0 0 55.000000 42.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,42.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 190 l0 -190 275 0 275 0 0 190 0 190 -90 0 -90 0 0 -30 0 -30 -100 0 -100 0 0 30 0 30 -85 0 -85 0 0 -190z m240 -30 l0 -90 -85 0 -85 0 0 90 0 90 85 0 85 0 0 -90z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStaff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Staff.ab079948677aff532de7358a722a7bb3.svg";